<template>
  <div id="bgroup-window" class="lity-hide">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h3>
            {{ name
            }}
            <span v-if="type != 'transport-station'">
                {{ grupo_espacios.length }} {{ $t("gruposvallas") }}
              </span>
            <span v-if="type == 'transport-station' && subtitle" class="bgroup-subtitle">{{ subtitle }}</span>
          </h3>
        </div>

        <div
          class="col-5 col-md-4 bgroup-item"
          v-for="(item, index) in grupo_espacios"
          :key="'cont_unidad_' + index"
        >
          <div class="card">
            <a href="#billboard-window" @click="showDetalles(item)">
              <vue-load-image>
                <img
                  slot="image"
                  class="card-img-top"
                  :src="'/image/' + item.images[0].image_path"
                />
                <vue-loading
                  slot="preloader"
                  class="preloader-img-min"
                  type="spin"
                  color="#d9544e"
                  :size="{ width: '50px', height: '50px' }"
                ></vue-loading>
                <div slot="error" class="error-msg-mini-img-group">
                  <p>Ha ocurrido un error.</p>
                </div>
              </vue-load-image>

              <!-- <img :src="'https://vallas.do/image/'+item.images[0].image_path" class="card-img-top" :alt="item.address"  /> -->
            </a>
            <div v-if="type != 'transport-station'" class="card-body">
                <h5 class="card-title">
                  <i class="far fa-compass" title="De cara hacia el..."></i>
                  {{ returnDir(item.facing_id).name }}
                </h5>
                <a href="#billboard-window" @click="showDetalles(item)">
                  <h4>{{ item.address }}</h4>
                </a>
              </div>
            <div v-if="type == 'transport-station'" class="card-body">
              <h5 v-if="item.part_circuit" class="station-card-title">
                <img src="/img/screen-vplay.svg" alt="screen"> x
                <span> {{ item.screens_circuit }} </span>
              </h5>
              <h5 v-if="!item.part_circuit" class="station-card-title">
                <img src="/img/screen-vplay.svg" alt="screen">
              </h5>
              <a href="#billboard-window" @click="showDetalles(item)">
                <h4>{{ item.subtitle ? item.subtitle : item.address }}</h4>
              </a>
            </div>
          </div>
        </div>

        <div v-if="type == 'transport-station' && shows_transit_data" class="col-md-12">
          <div class="station-transit">
            <div class="station-transit-left">
              <img src="/img/icon_walking.png" alt="people">
            </div>
            <div class="station-transit-right">
              <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="transit_per_month"
                        />
              <br><span>personas/mes</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import * as vallas_request from "../../request/vallas.js";
import * as usage_request from "../../request/usage.js";
import IOdometer from "vue-odometer";

//mixins
import VallasMixin from "../../mixins/vallas";

import { VueLoading } from "vue-loading-template";
import VueLoadImage from "vue-load-image";

export default {
  props: ["locations_", "grupos", "cardinal_directions"],
  mixins: [VallasMixin],
  components: {
    VueLoading,
    IOdometer,
    "vue-load-image": VueLoadImage,
  },
  mounted() {
    $(document).ready(function () {
      $(document).on("lity:open", function () {
        document.getElementById("app").style.position = "fixed";
      });

      $(document).on("lity:close", function () {
        document.getElementById("app").style.position = "relative";
      });
    });
  },
  data() {
    return {
      grupo_espacios: [],
      espacios: [],
      name: "",
      subtitle: "",
      shows_transit_data: "",
      transit_per_month: 0,
      type: '',
    };
  },
  methods: {
    show(id, grupo) {
      this.grupo_espacios = [];
      let vm = this;
      let grupo_ = _.filter(this.grupos, { group_id: id });
      vm.espacios = grupo_;

      for (const item of vm.espacios) {
        if (!_.find(vm.grupo_espacios, { id: item.billboard_id })) {
          vallas_request.get(item.billboard_id).then((response2) => {
            vm.grupo_espacios.push({ ...response2.data.data, order: item.id, part_circuit: response2.data.data.part_circuit && response2.data.data.part_circuit === 'yes' });
            vm.grupo_espacios.sort(function (a, b) {
              return a.order - b.order;
            });
          });
        }
      }

      if (grupo) {
        vm.name = grupo.name;
        vm.subtitle = grupo.subtitle;
        vm.shows_transit_data = grupo.shows_transit_data;
        vm.transit_per_month = grupo.transit_per_month ? 9999 : null;
        vm.type = grupo.group_type

        setTimeout(() => {
          vm.transit_per_month = parseInt( grupo.transit_per_month);
        }, 100);
      }

      lity("#bgroup-window");
    },
    showDetalles(marker) {
      let result = _.find(this.locations_, { id: marker.id });
      usage_request.post({
        views: 1,
        id_billboard: result.id,
      });
      this.$parent.$refs.detalles_valla_modal.show({...result, group_type: this.type});
    },
  },
};
</script>

<i18n src="@/locale/modals/grupoDeVallas.json" />
